import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import weekOfYear from 'dayjs/plugin/weekOfYear';

const getUserTimeZone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(weekOfYear);

export const initializeDate = () => {
  const userTimeZone = getUserTimeZone();
  dayjs.tz.setDefault(userTimeZone);
};
